module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.803 19.339l9.193-9.193a.5.5 0 01.707 0l.707.708a.5.5 0 010 .707l-9.546 9.546a2 2 0 01-2.828 0l-3.89-3.89a.5.5 0 010-.707l.708-.707a.5.5 0 01.707 0l3.535 3.536a.5.5 0 00.707 0z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/basic/asda-check.svg
// module id = 617
// module chunks = 0